import React, { useMemo, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
  Input,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { HOSPITAL_LIST_QUERY } from "../../config/Queries";

function HospitalList() {
  const { data, loading } = useQuery(HOSPITAL_LIST_QUERY);
  const history = useHistory();
  const [keyword, setKeyword] = useState("");

  const hospitals = useMemo(() => {
    const list = data?.listHospital || [];
    if (!keyword.trim()) {
      return list;
    }
    const lowerKeyword = keyword.trim().toLowerCase();
    return list.filter(
      (item) =>
        item.name?.toLowerCase().includes(lowerKeyword) ||
        item.address?.toLowerCase().includes(lowerKeyword) ||
        item.phone?.includes(lowerKeyword)
    );
  }, [data, keyword]);

  return (
    <>
      {!loading && (
        <div className="content">
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">병원 리스트</CardTitle>
                </CardHeader>
                <CardBody>
                  <Row className="m-b-15">
                    <Col xs="12" sm="6">
                      <Input
                        placeholder="병원명, 주소, 전화번호 검색"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                      />
                    </Col>
                    <Col xs="12" sm="6" className="text-right">
                      <Button
                        onClick={() => history.push("/admin/hospitals/write")}
                        className="btn-inverse"
                      >
                        <i className="fas fa-pen m-r-5"></i>
                        <span>병원 등록</span>
                      </Button>
                    </Col>
                  </Row>
                  <Table responsive hover>
                    <colgroup>
                      <col width="8%" />
                      <col width="12%" />
                      <col width="20%" />
                      <col width="*" />
                      <col width="15%" />
                    </colgroup>
                    <thead className="text-primary">
                      <tr>
                        <th>번호</th>
                        <th>로고</th>
                        <th>병원명</th>
                        <th>주소</th>
                        <th>전화번호</th>
                      </tr>
                    </thead>
                    <tbody>
                      {hospitals.map((item) => (
                        <tr
                          key={item.id}
                          onClick={() =>
                            history.push(`/admin/hospitals/${item.id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <td>{item.id}</td>
                          <td>
                            {item.logo ? (
                              <img
                                src={item.logo}
                                alt={item.name}
                                style={{
                                  width: 48,
                                  height: 48,
                                  objectFit: "cover",
                                  borderRadius: 4,
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{item.name}</td>
                          <td>{item.address || "-"}</td>
                          <td>{item.phone || "-"}</td>
                        </tr>
                      ))}
                      {hospitals.length === 0 && (
                        <tr>
                          <td colSpan="5" className="text-center">
                            등록된 병원이 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default HospitalList;
